const app = {
  name: process.env.REACT_APP_PRODUCT_NAME,
  
};

export default app;
